import { CheckCircleIcon, ExclamationTriangleIcon, InformationCircleIcon } from '@heroicons/react/24/outline'

import cn from '@/utilities/cn'

export default function ModalVariantLogo({ variant }: { variant: 'error' | 'warning' | 'success' | 'info' }) {
  return (
    <div
      className={cn(
        'mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10',
        {
          'bg-red-100': variant === 'error',
          'bg-yellow-100': variant === 'warning',
          'bg-green-100': variant === 'success',
          'bg-brand-50': variant === 'info'
        }
      )}
    >
      {variant === 'error' && <ExclamationTriangleIcon className="h-7 w-7 text-red-400" aria-hidden="true" />}
      {variant === 'warning' && <ExclamationTriangleIcon className="h-7 w-7 text-yellow-400" aria-hidden="true" />}
      {variant === 'success' && <CheckCircleIcon className="h-7 w-7 text-green-400" aria-hidden="true" />}
      {variant === 'info' && <InformationCircleIcon className="h-7 w-7 text-brand-200" aria-hidden="true" />}
    </div>
  )
}
